import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { Popconfirm, message, Tabs, Badge } from 'antd'

// Util
import environment from '../../../environment'
import { apiPOSTReq } from '../../../Utils/api'
import { capitalizeFirstLetter, getDateByTZ, getDateInLocalTZ, getLogoFromDomain, getResourcePerm, getUserApps, renderBankIcon, toCurrency } from '../../../Utils/util'
import PageHeader from "../../Reusable/PageHeader"
import { Flex, FlexColumn, CardContainer } from '../../Reusable/Container'
import { Dropdown, Menu } from '../../Reusable/Dropdown'
import { LabeledInput } from '../../Reusable/Input'
import Import from './Import'

// Images
import { ErrorAlert } from '../../Reusable/Alert'
import AlertModal from '../../Reusable/AlertModal'
import { Tag, Text } from '../../Reusable/Text'
import { Image } from '../../Reusable/Image'
import { Button, TextButton, ImageButton } from '../../Reusable/Button'
import { withTheme } from 'styled-components'
import Modal from 'antd/lib/modal/Modal'
import { addDataToStore, SAVE_DATA } from '../../../Actions/actions'
import ModalClose from '../../../Images/modal-close.png'
import Search from '../../../Images/search.png'
import More from "../../../Images/more.png"
import Edit from "../../../Images/edit.png"
import Upload from "../../../Images/upload.svg"
import Add from "../../../Images/add-white.svg"
import TableView from '../../Reusable/TableView'
import { InitialCircle } from '../../Reusable/InitialCircle'
import hexToRgba from 'hex-to-rgba'
import { isEmpty } from 'underscore'

const { TabPane } = Tabs


class Index extends Component {
    ref = null
    loadingAnimation = null
    state = {
        loading: false,
        pagination: {
            current: 1,
            pageSize: 50,
        },
        inactivePagination: {
            current: 1,
            pageSize: 50,
        },
        searchPagination: {
            current: 1,
            pageSize: 50,
        },
        accountingSW: '',
        tab: 'active',
        inactiveVendors: [],
        sortFieldName: "VendorName",
        sortDirection: "ASC"
    }

    componentDidMount() {
        this.fetchData({ pagination: this.state.pagination })
        this.fetchRecipientPM()
    }

    componentDidUpdate(prevProps) {
        let { location } = this.props
        var state = location.state ? location.state : {}
        if (state.reloadData) {
            this.props.location.state = {}
            this.fetchData({ pagination: this.state.pagination })
        }
    }

    fetchData(options) {
        const { pagination, sortDirection, sortFieldName } = options;

        var body = {
            "size": pagination.pageSize,
            "page": pagination.current - 1,
            "viewBy": "FILTER_ACTIVE",
            "sortFieldName": "LastTransferDate",
            "sortDirection": "DESC"
        }

        if(sortFieldName) {
            body.sortFieldName = sortFieldName;
            body.sortDirection = sortDirection || "DESC";
        }

        this.setState({ loading: true })
        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/getVendors`, {}, body, (err, resp) => {
            this.setState({ loading: false })
            try {
                const data = resp
                if (data.result) {
                    this.setState({
                        ...data,
                        pagination: {
                            ...pagination,
                            total: data.count
                        },
                        sortFieldName: body.sortFieldName,
                        sortDirection: body.sortDirection
                    })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getActiveCustomers", error, err, resp)
                this.setState({ loading: false })
                ErrorAlert({ description: error.message })
            }
        })
    }

    deactivateVendor = (vendor) => {
        const body = {
            "vendorId": vendor.id
        }

        this.setState({ deactivateLoading: true })
        console.log("/payables/vendors/deactivate", JSON.stringify(body))

        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/deactivate`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                this.setState({ deactivateLoading: false })
                const data = resp
                console.log("/payables/vendors/deactivate", data)
                if (data.result) {
                    message.success(`Successfully deactivated!`)
                    this.fetchData({ pagination: this.state.pagination, sortFieldName: this.state.sortFieldName, sortDirection: this.state.sortDirection })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR deactivatevendor", error, resp)
                ErrorAlert({ description: error.message })
            } finally {
                this.setState({ showDeactivate: false, vendorToDelete: null })
            }
        })
    }

    selectRow = (record) => {
        this.props.history.push({
            pathname: '/payables/vendors/details',
            state: { vendor: record }
        })
    }

    handleTableChange = (pagination, filters, sorter) => {
            sorter = sorter || {};
            var sortFieldName = null;
            var sortDirection = null;
            // console.log("handleTableChange pagination, filters, sorter", pagination, filters, sorter)
            if(sorter.order) {
                if(sorter.order == 'ascend') sortDirection = 'ASC';
                else sortDirection = 'DESC';
            }
            
            if(sorter.field) {
                sortFieldName = capitalizeFirstLetter(sorter.field);
            }

            if(!isEmpty(this.state.vendorSearch)) {
                this.onSearch({ vendorSearch: this.state.vendorSearch, pagination, sortDirection, sortFieldName });
            } else {
                this.fetchData({ pagination, sortDirection, sortFieldName });
            }   
        }

    setRowClassName = (record) => {
        var { selectedVendor } = this.state
        selectedVendor = selectedVendor || {}
        console.log("setRowClassName", record, selectedVendor, record.id === selectedVendor.id ? 'selected-row' : '')
        return record.id === selectedVendor.id ? 'selected-row' : ''
    }

    handleNewVendor = () => {
        this.props.history.push({
            pathname: '/payables/vendors/new',
            state: { newVendor: true }
        })
    }

    handleImportVendor = () => {
        this.setState({ bill: null, vendor: null, category: null, showImportModal: true, modalWidth: 700 })
    }

    onSearch = ({ vendorSearch, pagination, sortFieldName, sortDirection }) => {
        if (!vendorSearch) {
            return this.fetchData({ pagination: this.state.pagination, sortFieldName: this.state.sortFieldName, sortDirection: this.state.sortDirection })
        }
        let searchPagination = pagination || this.state.searchPagination
        const body = {
            "size": searchPagination.pageSize,
            "page": searchPagination.current - 1,
            "viewBy": "FILTER_BY_ACTIVE",
            sortFieldName: sortFieldName || this.state.sortFieldName, 
            sortDirection: sortDirection || this.state.sortDirection
        }

        if (vendorSearch && vendorSearch.includes("@")) {
            body.searchEmail = vendorSearch
        } else {
            body.searchStr = vendorSearch
        }

        this.setState({ loading: true })
        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/lookupVendors`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            this.setState({ loading: false })
            try {
                const data = resp
                console.log("/lookupVendors", data)
                if (data.result) {
                    this.setState({
                        ...data,
                        pagination: {
                            ...searchPagination,
                            total: data.count
                        },
                        sortFieldName: body.sortFieldName, 
                        sortDirection: body.sortDirection
                    })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getContractors", error, err, resp)
                ErrorAlert({ description: error.message })
            }
        })
    }

    onSearchChange = (e) => {
        this.setState({ vendorSearch: e.target.value })
        this.setState({
            pagination: {
                current: 1,
                pageSize: 50
            }
        })
        this.onSearch({ vendorSearch: e.target.value });
    }

    fetchRecipientPM = () => {
        this.setState({ loading: true })

        const body = { railType: null }

        apiPOSTReq(`${environment.bbBaseUrl}/bb/getPaymentMethodsByRecipients`, null, body, (err, resp) => {
            try {
                const data = resp
                if (data.result) {
                    if (err) throw new Error(err)

                    if (resp && resp.result) {
                        var sortedArray = Object.values(resp.recipientMap || []).sort((a, b) => {
                            // Handle null values by setting them to a default date in the distant past
                            const dateA = a.lastTransferDate || "1900-01-01";
                            const dateB = b.lastTransferDate || "1900-01-01";
                            return new Date(dateB) - new Date(dateA);  // Sort in descending order
                        });

                        this.setState({
                            loading: false,
                            // recipients: sortedArray,
                            noData: (!sortedArray || sortedArray.length === 0),
                            paymentMethodRecipientMap: resp.paymentMethodRecipientMap,
                            recipientMap: resp.recipientMap,
                        })
                    }
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getPaymentMethodsByRecipients", error, err, resp)
            } finally {
                this.setState({
                    loading: false
                })
            }
        })
    }

    render() {
        var { theme } = this.props
        var { pagination, vendors, tab, inactiveVendors, paymentMethodRecipientMap, showDeactivate, deactivateLoading, vendorToDelete, sortFieldName, sortDirection } = this.state
        var vendors = vendors || []

        var columns = [
            {
                title: 'Name',
                dataIndex: 'vendorName',
                key: 'vendorName',
                sorter: true,
                render: (item, record) => (
                    <Flex start centerHorizontally gap='8px'>
                        <div>
                            <InitialCircle size={30} name={item} useFirstWordOnly={true} logoUrl={getLogoFromDomain(record.primaryEmail)} />
                        </div>
                        
                        <FlexColumn start gap='2px'>
                            <Flex start centerH gap='8px'>
                                <Text weight={500} color={theme.colors.primary2}>{item}</Text>
                                {record.openInboxItemsCount > 0 && <Tag primary>{record.openInboxItemsCount} New | ${toCurrency(record.totalOpenInboxAmount)} total</Tag>}
                            </Flex>
                            
                            <Flex start gap='4px'>
                                <Text size={'12px'} height={'14px'} weight={500} color={hexToRgba(this.props.theme.colors.primary2, 0.5)}>Balance: ${toCurrency(record.outstandingBalance)}</Text>
                                {record.overdueBillsCount > 0 && <Text size={'12px'} height={'14px'} weight={500} color={hexToRgba(this.props.theme.colors.primary2, 0.5)}>| {record.overdueBillsCount} bills overdue</Text>}
                            </Flex>
                            
                        </FlexColumn>
                    </Flex>
                )
            },
            {
                title: 'Recent Payment (ET)',
                dataIndex: 'lastTransferDate',
                key: 'lastTransferDate',
                align: 'right',
                sorter: true,
                render: date => <>
                    {
                        <Text margin='0 0 0 8px'>{date ? getDateByTZ(date, null, "America/New_York") : "--"}</Text>
                    }
                </>
            }
        ]

        const vendorPerm = getResourcePerm("Payables.Vendors")
        const { vendorUploadJobId } = this.props.aionStore

        return (
            <>
                <FlexColumn className='main-padding'>
                    <PageHeader
                        titleText="Bill Payments"
                        subtitle="Bill Payments"

                    />

                    {/* <CardContainer style={{ marginBottom: 24 }} grow padding='8px 24px 24px'> */}
                    {/* <Tabs activeKey={tab} onClick={() => { }} onChange={(key) => this.setState({ tab: key })} style={{ marginBottom: 12 }}>
                        <TabPane tab="Active" key="active" />
                        <TabPane tab="Inactive" key="inactive" />
                    </Tabs> */}

                    <TableView
                        id="vendor-table"
                        titleText="Vendors"
                        tableLayout='auto'
                        columns={columns}
                        dataSource={tab === 'active' ? vendors : inactiveVendors}
                        rowKey='id'
                        pagination={pagination}
                        loading={this.state.loading}
                        // scroll={{ y: '700px', x: '100%' }}
                        sortFieldName={sortFieldName}
                        sortDirection={sortDirection}
                        onRow={(record) => (vendorPerm.manage && {
                            onClick: () => {
                                this.selectRow(record)
                            }
                        })}
                        // rowClassName={this.setRowClassName}
                        style={{ flex: 1 }}
                        onChange={this.handleTableChange}
                        ctaContent={
                            <Flex start centerHorizontally gap='24px'>
                                <TextButton onClick={this.handleImportVendor} disabled={vendorUploadJobId} rightIcon={<Image src={Upload} />} text='BULK IMPORT' />
                                <Button solid permtype="Payables.Vendors" onClick={this.handleNewVendor} icon={<Image src={Add} />} text='ADD VENDOR' />
                            </Flex>
                        }
                        ctaSecondary={
                            <LabeledInput
                                id="searchTerm"
                                key="searchTerm"
                                placeholder="Search vendors"
                                prefixIcon={<Image width='12px' height='12px' src={Search} />}
                                onChange={this.onSearchChange}
                                width='250px'
                                nomargin
                            />
                        }
                    />
                    {/* </CardContainer> */}
                    <Modal
                        visible={this.state.showImportModal}
                        footer={null}
                        closable={true}
                        maskClosable={true}
                        width={this.state.modalWidth}
                        destroyOnClose={true}
                        onCancel={() => this.setState({ showImportModal: false })}
                        closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                    >
                        <Import
                            downloadLink="/Vendor_template.csv"
                            downloadName="Vendor_template.csv"
                            actionUrl={`${environment.payBaseUrl}/payables/vendors/uploadVendors`}
                            uploadTypeTitle="Vendor"
                            uploadType="vendor"
                            submitComplete={
                                (vendorUploadJobId) => {
                                    if (vendorUploadJobId) {
                                        this.props.dispatch(addDataToStore(SAVE_DATA, { vendorUploadJobId: vendorUploadJobId }))
                                    }

                                    this.setState({ showImportModal: false })
                                }
                            }
                        />
                    </Modal>
                </FlexColumn>

                <AlertModal
                    deactivate
                    visible={showDeactivate}
                    loading={deactivateLoading}
                    title='Deactivate this vendor?'
                    description="Are you sure you want to deactivate this vendor?"
                    descWidth={'350px'}
                    buttonTitle='DEACTIVATE'
                    cancelButtonText='CANCEL'
                    onConfirm={() => {
                        this.deactivateVendor(vendorToDelete)
                    }}
                    onCancel={() => this.setState({ showDeactivate: false, vendorToDelete: null })}
                />
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        aionStore: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Index)))